import React, { useState, useEffect } from 'react';
import './PageStyles.css';

const CargaAsistencia = () => {

  // —————— Eliminación de Estudiante ——————
  const [deleteRut, setDeleteRut] = useState('');
  const [deleteMessage, setDeleteMessage] = useState('');
  const [deleting, setDeleting] = useState(false);

  // NUEVO: Estados para la eliminación por fecha
  const [deleteYear, setDeleteYear] = useState('');
  const [deleteMonth, setDeleteMonth] = useState('');
  const [deleteByDateMessage, setDeleteByDateMessage] = useState('');
  const [deletingByDate, setDeletingByDate] = useState(false);

  const handleDeleteRutChange = e => {
    setDeleteRut(e.target.value);
  };

  const handleDeleteAsistencia = async e => {
    e.preventDefault();
    setDeleteMessage('');
    if (!deleteRut) {
      setDeleteMessage('Por favor, ingrese un RUT.');
      return;
    }
    if (!window.confirm('¿Está seguro de eliminar TODOS los registros de asistencia de este alumno?')) return;
    setDeleting(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        `https://asistencia-betterland.onrender.com/asistencia/estudiante?rut=${deleteRut}`,
        {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );
      const data = await res.json();
      if (res.ok) {
        setDeleteMessage(data.message);
        setDeleteRut('');
      } else {
        setDeleteMessage(data.message || 'Error al eliminar registros.');
      }
    } catch (err) {
      setDeleteMessage('Error de conexión con el servidor.');
    } finally {
      setDeleting(false);
    }
  };

  // NUEVO: Lógica para eliminar asistencia por fecha (mes/año)
  const handleDeleteByDate = async e => {
    e.preventDefault();
    setDeleteByDateMessage('');
    if (!deleteYear || !deleteMonth) {
      setDeleteByDateMessage('Por favor, seleccione año y mes.');
      return;
    }

    const monthName = deleteMonth !== 'all' ? new Date(0, deleteMonth - 1).toLocaleString('es-CL', { month: 'long' }) : '';
    const confirmationMessage = deleteMonth === 'all'
      ? `¿Está seguro de eliminar TODOS los registros de asistencia del año ${deleteYear}? Esta acción no se puede deshacer.`
      : `¿Está seguro de eliminar los registros de asistencia de ${monthName} de ${deleteYear}? Esta acción no se puede deshacer.`;

    if (!window.confirm(confirmationMessage)) return;

    setDeletingByDate(true);
    try {
      const token = localStorage.getItem('token');
      // Si el mes es "all", se omite el parámetro `month` para que el backend elimine el año completo.
      let url = `https://asistencia-betterland.onrender.com/asistencia?year=${deleteYear}`;
      if (deleteMonth !== 'all') {
        url += `&month=${deleteMonth}`;
      }

      const res = await fetch(url, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      const data = await res.json();
      if (res.ok) {
        setDeleteByDateMessage(data.message || 'Registros eliminados con éxito.');
        setDeleteYear('');
        setDeleteMonth('');
      } else {
        setDeleteByDateMessage(data.message || 'Error al eliminar los registros.');
      }
    } catch (err) {
      setDeleteByDateMessage('Error de conexión con el servidor.');
    } finally {
      setDeletingByDate(false);
    }
  };

  // ——— Cambiar RUT de Estudiante ———
  const [oldRut, setOldRut] = useState('');
  const [newRut, setNewRut] = useState('');
  const [updateMessage, setUpdateMessage] = useState('');
  const [updatingRut, setUpdatingRut] = useState(false);

  const handleOldRutChange = e => setOldRut(e.target.value);
  const handleNewRutChange = e => setNewRut(e.target.value);

  const handleUpdateRut = async e => {
    e.preventDefault();
    setUpdateMessage('');
    if (!oldRut || !newRut) {
      setUpdateMessage('Por favor, ingrese RUT antiguo y RUT nuevo.');
      return;
    }
    if (!window.confirm(`¿Cambiar RUT ${oldRut} → ${newRut}?`)) return;
    setUpdatingRut(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(
        'https://asistencia-betterland.onrender.com/asistencia/estudiante',
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ oldRut, newRut })
        }
      );
      const data = await res.json();
      if (res.ok) {
        setUpdateMessage(data.message);
        setOldRut('');
        setNewRut('');
      } else {
        setUpdateMessage(data.message || 'Error al actualizar el RUT.');
      }
    } catch (err) {
      setUpdateMessage('Error de conexión con el servidor.');
    } finally {
      setUpdatingRut(false);
    }
  };

  // Estados para Asistencia
  const [file, setFile] = useState(null);
  const [year, setYear] = useState('');
  const [month, setMonth] = useState('');
  const [message, setMessage] = useState('');
  const [uploading, setUploading] = useState(false);

  // Estados para Datos de Estudiantes por CSV (Fluidez)
  const [studentFile, setStudentFile] = useState(null);
  const [studentYear, setStudentYear] = useState('');
  const [studentMessage, setStudentMessage] = useState('');
  const [studentUploading, setStudentUploading] = useState(false);

  // Estados para Administración de Estudiantes (tabla)
  const [filterYear, setFilterYear] = useState('');
  const [filterNivel, setFilterNivel] = useState('');
  const [students, setStudents] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(false);

  // Estados para Agregar Estudiante Manualmente
  const [manualStudent, setManualStudent] = useState({
    yearFluidez: '',
    rut: '',
    firstName: '',
    lastNamePaternal: '',
    lastNameMaternal: '',
    nivel: ''
  });
  const [manualMessage, setManualMessage] = useState('');

  // Estados para Exportar CSV de Estudiantes con 100% de Asistencia
  const [csvExportYear, setCsvExportYear] = useState('');
  const [csvExportMonth, setCsvExportMonth] = useState('');
  const [csvExportMessage, setCsvExportMessage] = useState('');
  const [csvExporting, setCsvExporting] = useState(false);

  // Lista de años para los selects
  const years = ['', '2026', '2025', '2024', '2023', '2022'];

  // Mapeo para convertir número de mes a abreviatura (según lo usado en /matriculas)
  const monthMapping = {
    "1": "ene",
    "2": "feb",
    "3": "mar",
    "4": "abr",
    "5": "may",
    "6": "jun",
    "7": "jul",
    "8": "ago",
    "9": "sep",
    "10": "oct",
    "11": "nov",
    "12": "dic"
  };

  // Constantes para obtener todos los cursos
  const tipos = ["10", "110", "310"];
  const nivelOptionsMap = {
    "10": [4, 5],
    "110": [1, 2, 3, 4, 5, 6, 7, 8],
    "310": [1, 2, 3, 4]
  };
  const courses = ["A", "B"];

  // =============================
  // Sección de Asistencia
  // =============================
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!file || !year || !month) {
      setMessage('Por favor, complete todos los campos de asistencia.');
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('year', year);
    formData.append('month', month);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        'https://asistencia-betterland.onrender.com/asistencia/upload',
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData
        }
      );

      if (response.ok) {
        setMessage('Archivo de asistencia cargado con éxito.');
        setFile(null);
        setYear('');
        setMonth('');
      } else {
        setMessage('Error al cargar el archivo de asistencia.');
      }
    } catch (error) {
      setMessage('Error al conectar con el servidor para asistencia.');
    } finally {
      setUploading(false);
    }
  };

  // =============================
  // Sección de Datos de Estudiantes (CSV) - Fluidez
  // =============================
  const handleStudentFileChange = (e) => {
    setStudentFile(e.target.files[0]);
  };

  const handleStudentUpload = async (e) => {
    e.preventDefault();
    setStudentMessage('');

    if (!studentFile || !studentYear) {
      setStudentMessage('Por favor, complete todos los campos de datos de estudiantes.');
      return;
    }

    setStudentUploading(true);
    const formData = new FormData();
    formData.append('file', studentFile);
    formData.append('year', studentYear);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        'https://asistencia-betterland.onrender.com/fluidez/estudiantes/upload',
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData
        }
      );

      if (response.ok) {
        setStudentMessage('Datos de estudiantes cargados con éxito.');
        setStudentFile(null);
        setStudentYear('');
      } else {
        setStudentMessage('Error al cargar el archivo de estudiantes.');
      }
    } catch (error) {
      setStudentMessage('Error al conectar con el servidor para datos de estudiantes.');
    } finally {
      setStudentUploading(false);
    }
  };

  // Función para descargar la plantilla CSV
  const downloadCSVTemplate = () => {
    const csvContent = "\uFEFF" + "año;rut;nombres;apellido_paterno;apellido_materno;nivel\n2025;;;;;\n";
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "plantilla_estudiantes.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Función para descargar el log desde el backend
  const downloadLog = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        'https://asistencia-betterland.onrender.com/logs/download',
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      if (!response.ok) {
        throw new Error('Error al descargar el log');
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'fluidez-changes.log';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error descargando el log:', error);
    }
  };

  // =============================
  // Sección de Administración de Estudiantes
  // =============================
  const fetchStudents = async () => {
    if (!filterYear) return;
    setLoadingStudents(true);
    try {
      const token = localStorage.getItem('token');
      let url = `https://asistencia-betterland.onrender.com/fluidez/estudiantes?yearFluidez=${filterYear}`;
      if (filterNivel) {
        url += `&nivel=${filterNivel}`;
      }
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        data.sort((a, b) => a.lastnamepaternal.localeCompare(b.lastnamepaternal));
        setStudents(data);
      } else {
        setStudents([]);
      }
    } catch (error) {
      console.error("Error al cargar estudiantes:", error);
    } finally {
      setLoadingStudents(false);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, [filterYear, filterNivel]);

  const deleteStudent = async (rut) => {
    if (!filterYear) return;
    if (!window.confirm("¿Está seguro de eliminar este estudiante?")) return;
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        `https://asistencia-betterland.onrender.com/fluidez/estudiantes?yearFluidez=${filterYear}&rut=${rut}`,
        {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      if (response.ok) {
        fetchStudents();
      } else {
        alert("Error al eliminar el estudiante");
      }
    } catch (error) {
      console.error("Error al eliminar estudiante:", error);
    }
  };

  // =============================
  // Agregar Estudiante Manualmente
  // =============================
  const handleManualChange = (e) => {
    const { name, value } = e.target;
    setManualStudent(prev => ({ ...prev, [name]: value }));
  };

  const handleManualSubmit = async (e) => {
    e.preventDefault();
    setManualMessage('');
    const { yearFluidez, rut, firstName, lastNamePaternal, lastNameMaternal, nivel } = manualStudent;
    if (!yearFluidez || !rut || !firstName || !lastNamePaternal || !lastNameMaternal || !nivel) {
      setManualMessage("Por favor, complete todos los campos del formulario.");
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(
        'https://asistencia-betterland.onrender.com/fluidez/estudiantes',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(manualStudent)
        }
      );
      if (response.ok) {
        setManualMessage("Estudiante agregado exitosamente.");
        setManualStudent({
          yearFluidez: '',
          rut: '',
          firstName: '',
          lastNamePaternal: '',
          lastNameMaternal: '',
          nivel: ''
        });
        fetchStudents();
      } else {
        setManualMessage("Error al agregar el estudiante.");
      }
    } catch (error) {
      console.error("Error al agregar estudiante manual:", error);
      setManualMessage("Error al conectar con el servidor.");
    }
  };

  // =============================
  // Exportar CSV 100% de Asistencia
  // =============================
  const handleExportCSV = async () => {
    if (!csvExportYear || !csvExportMonth) {
      setCsvExportMessage("Por favor, complete año y mes de exportación.");
      return;
    }
    setCsvExporting(true);
    setCsvExportMessage("");
    const monthAbbr = monthMapping[csvExportMonth];
    const token = localStorage.getItem('token');

    // Generamos promesas para cada combinación
    const promises = [];
    for (const tipo of tipos) {
      for (const nivel of nivelOptionsMap[tipo]) {
        for (const curso of courses) {
          const url = `https://asistencia-betterland.onrender.com/matriculas?year=${csvExportYear}&tipoEnsenanza=${tipo}&nivel=${nivel}&curso=${curso}`;
          promises.push(
            fetch(url, { headers: { 'Authorization': `Bearer ${token}` } })
              .then(res => res.ok ? res.json() : [])
              .then(data => data.map(row => ({
                ...row,
                tipo_ensenanza: tipo,
                nivel,
                curso
              })))
              .catch(() => [])
          );
        }
      }
    }

    try {
      const results = await Promise.all(promises);
      const allStudents = results.flat();
      const filtered = allStudents.filter(s => {
        const att = parseFloat(s[monthAbbr]);
        return !isNaN(att) && att === 100;
      });
      if (filtered.length === 0) {
        setCsvExportMessage("No se encontraron estudiantes con 100% de asistencia en el mes seleccionado.");
        setCsvExporting(false);
        return;
      }
      let csv = "\uFEFF" + "año;tipo de enseñanza;nivel;curso;nombre;rut;asistencia\n";
      filtered.forEach(s => {
        csv += [
          csvExportYear,
          s.tipo_ensenanza,
          s.nivel,
          s.curso,
          s.nombre,
          s.rut,
          s[monthAbbr]
        ].join(';') + '\n';
      });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `asistencia_100_${csvExportYear}_${monthAbbr}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setCsvExportMessage("CSV exportado exitosamente.");
    } catch (error) {
      setCsvExportMessage("Error al exportar el CSV.");
    } finally {
      setCsvExporting(false);
    }
  };

  return (
    <div className="page-content">
      <h2 className="page-title">Carga de Asistencia y Datos de Estudiantes</h2>

      {/* Primera fila */}
      <div style={{ display: 'flex', gap: '1rem' }}>
        {/* Asistencia */}
        <div className="card" style={{ flex: 1 }}>
          <h3>Subir Archivo de Asistencia</h3>
          <form onSubmit={handleSubmit} className="user-form">
            <div className="form-group">
              <label>Año</label>
              <select value={year} onChange={e => setYear(e.target.value)} required>
                {years.map((yr, i) => (
                  <option key={i} value={yr}>
                    {yr || 'Seleccione año'}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Mes</label>
              <select value={month} onChange={e => setMonth(e.target.value)} required>
                <option value="">Seleccione mes</option>
                {[...Array(12)].map((_, i) => (
                  <option key={i+1} value={i+1}>
                    {new Date(0, i).toLocaleString('es-CL',{ month:'long' })}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Archivo de Asistencia</label>
              <input type="file" onChange={handleFileChange} required />
            </div>
            <button type="submit" className="create-button" disabled={uploading}>
              {uploading ? 'Subiendo...' : 'Subir Archivo'}
            </button>
          </form>
          {uploading && <div className="spinner"></div>}
          {message && <p className="message">{message}</p>}
        </div>

        {/* Fluidez CSV */}
        <div className="card" style={{ flex: 1 }}>
          <h3>Subir Archivo de Datos de Estudiantes Fluidez</h3>
          <button onClick={downloadCSVTemplate} className="download-button">
            Descargar Plantilla CSV
          </button>
          <form onSubmit={handleStudentUpload} className="user-form">
            <div className="form-group">
              <label>Año de Datos</label>
              <select value={studentYear} onChange={e => setStudentYear(e.target.value)} required>
                {years.map((yr, i) => (
                  <option key={i} value={yr}>
                    {yr || 'Seleccione año'}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Archivo (CSV)</label>
              <input type="file" onChange={handleStudentFileChange} accept=".csv" required />
            </div>
            <button type="submit" className="create-button" disabled={studentUploading}>
              {studentUploading ? 'Subiendo...' : 'Subir Datos de Estudiantes'}
            </button>
          </form>
          {studentUploading && <div className="spinner"></div>}
          {studentMessage && <p className="message">{studentMessage}</p>}
          <button onClick={downloadLog} className="create-button" style={{ marginTop: '1rem' }}>
            Descargar Log
          </button>
        </div>
      </div>

      {/* Segunda fila */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '2rem' }}>
  
  {/* Administración - Agregamos la clase card-full-width */}
  <div className="card card-full-width">
    <h3>Administración de Estudiantes Fluidez</h3>
          <div className="form-group">
            <label>Filtrar por Año</label>
            <select value={filterYear} onChange={e => setFilterYear(e.target.value)}>
              {years.map((yr, i) => (
                <option key={i} value={yr}>
                  {yr || 'Seleccione año'}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Filtrar por Nivel</label>
            <input
              type="text"
              placeholder="Nivel (ej: 1A, 1B)"
              value={filterNivel}
              onChange={e => setFilterNivel(e.target.value)}
            />
          </div>
          <button className="create-button" onClick={fetchStudents}>
            Cargar Estudiantes
          </button>
          {loadingStudents ? (
      <div className="spinner"></div>
    ) : (
      /* Usamos el nuevo contenedor y la nueva clase de tabla */
      <div className="asistencia-table-container"> 
        <table className="asistencia-custom-table">
          <thead>
            <tr>
              <th>RUT</th>
              <th>Nombres</th>
              <th>Apellido Paterno</th>
              <th>Apellido Materno</th>
              <th>Nivel</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {students.length > 0 ? (
              students.map(stu => (
                <tr key={stu.rut}>
                  <td>{stu.rut}</td>
                  <td>{stu.firstname}</td>
                  <td>{stu.lastnamepaternal}</td>
                  <td>{stu.lastnamematernal}</td>
                  <td>{stu.nivel}</td>
                  <td>
                    <button className="delete-button" onClick={() => deleteStudent(stu.rut)}>
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No se encontraron estudiantes.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )}
  </div>

        {/* Manual */}
        <div className="card card-full-width">
          <h3>Agregar Estudiante Manualmente Fluidez</h3>
          <form onSubmit={handleManualSubmit} className="user-form">
            <div className="form-group">
              <label>Año de Datos</label>
              <select
                name="yearFluidez"
                value={manualStudent.yearFluidez}
                onChange={handleManualChange}
                required
              >
                {years.map((yr, i) => (
                  <option key={i} value={yr}>
                    {yr || 'Seleccione año'}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>RUT</label>
              <input
                type="text"
                name="rut"
                placeholder="Ingrese el RUT"
                value={manualStudent.rut}
                onChange={handleManualChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Nombres</label>
              <input
                type="text"
                name="firstName"
                placeholder="Ingrese los nombres"
                value={manualStudent.firstName}
                onChange={handleManualChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Apellido Paterno</label>
              <input
                type="text"
                name="lastNamePaternal"
                placeholder="Ingrese el apellido paterno"
                value={manualStudent.lastNamePaternal}
                onChange={handleManualChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Apellido Materno</label>
              <input
                type="text"
                name="lastNameMaternal"
                placeholder="Ingrese el apellido materno"
                value={manualStudent.lastNameMaternal}
                onChange={handleManualChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Nivel</label>
              <input
                type="text"
                name="nivel"
                placeholder="Ej: 1A, 1B"
                value={manualStudent.nivel}
                onChange={handleManualChange}
                required
              />
            </div>
            <button type="submit" className="create-button">
              Agregar Estudiante
            </button>
          </form>
          {manualMessage && <p className="message">{manualMessage}</p>}
        </div>
      </div>

      {/* Fila de herramientas de administración */}
      <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem', flexWrap: 'wrap' }}>
        {/* ——— Cambiar RUT de Estudiante ——— */}
        <div className="card" style={{ flex: 1 }}>
          <h3>Cambiar RUT de Estudiante</h3>
          <form onSubmit={handleUpdateRut} className="user-form">
            <div className="form-group">
              <label>RUT Actual</label>
              <input
                type="text"
                placeholder="Ingrese RUT actual"
                value={oldRut}
                onChange={handleOldRutChange}
                required
              />
            </div>
            <div className="form-group">
              <label>RUT Nuevo</label>
              <input
                type="text"
                placeholder="Ingrese RUT nuevo"
                value={newRut}
                onChange={handleNewRutChange}
                required
              />
            </div>
            <button type="submit" className="create-button" disabled={updatingRut}>
              {updatingRut ? 'Actualizando...' : 'Actualizar RUT'}
            </button>
          </form>
          {updateMessage && <p className="message">{updateMessage}</p>}
        </div>

        {/* ——— Eliminación de Estudiante ——— */}
        <div className="card" style={{ flex: 1 }}>
          <h3>Eliminación de Estudiante</h3>
          <form onSubmit={handleDeleteAsistencia} className="user-form">
            <div className="form-group">
              <label>RUT</label>
              <input
                type="text"
                placeholder="Ingrese el RUT"
                value={deleteRut}
                onChange={handleDeleteRutChange}
                required
              />
            </div>
            <button type="submit" className="delete-button" disabled={deleting}>
              {deleting ? 'Eliminando...' : 'Eliminar Asistencia'}
            </button>
          </form>
          {deleteMessage && <p className="message">{deleteMessage}</p>}
        </div>

        {/* NUEVO: Tarjeta para eliminar por fecha */}
        <div className="card" style={{ flex: 1 }}>
          <h3>Eliminar Asistencia por Fecha</h3>
          <form onSubmit={handleDeleteByDate} className="user-form">
            <div className="form-group">
              <label>Año</label>
              <select value={deleteYear} onChange={e => setDeleteYear(e.target.value)} required>
                {years.map((yr, i) => (
                  <option key={i} value={yr}>
                    {yr || 'Seleccione año'}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label>Mes</label>
              <select value={deleteMonth} onChange={e => setDeleteMonth(e.target.value)} required>
                <option value="">Seleccione mes</option>
                <option value="all">Todos</option>
                {[...Array(12)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString('es-CL', { month: 'long' })}
                  </option>
                ))}
              </select>
            </div>
            <button type="submit" className="delete-button" disabled={deletingByDate}>
              {deletingByDate ? 'Eliminando...' : 'Eliminar Registros'}
            </button>
          </form>
          {deletingByDate && <div className="spinner"></div>}
          {deleteByDateMessage && <p className="message">{deleteByDateMessage}</p>}
        </div>
      </div>

      {/* Exportar CSV 100% */}
      <div className="card" style={{ marginTop: '2rem' }}>
        <h3>Exportar CSV de Estudiantes con 100% de Asistencia</h3>
        <form
          onSubmit={e => {
            e.preventDefault();
            handleExportCSV();
          }}
          className="user-form"
        >
          <div className="form-group">
            <label>Año</label>
            <select value={csvExportYear} onChange={e => setCsvExportYear(e.target.value)} required>
              {years.map((yr, i) => (
                <option key={i} value={yr}>
                  {yr || 'Seleccione año'}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Mes</label>
            <select value={csvExportMonth} onChange={e => setCsvExportMonth(e.target.value)} required>
              <option value="">Seleccione mes</option>
              {[...Array(12)].map((_, i) => (
                <option key={i+1} value={i+1}>
                  {new Date(0, i).toLocaleString('es-CL',{ month:'long' })}
                </option>
              ))}
            </select>
          </div>
          <button type="submit" className="create-button" disabled={csvExporting}>
            {csvExporting ? 'Exportando...' : 'Exportar CSV'}
          </button>
        </form>
        {csvExportMessage && <p className="message">{csvExportMessage}</p>}
      </div>
    </div>
  );
};

export default CargaAsistencia;